import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { Card, Modal, Button, Form, Col } from 'react-bootstrap';
import { motion } from 'framer-motion';
import '../../../Styles/Sales.css';
import Swal from 'sweetalert2';
import CustomPopup from '../../../ReusableBlocks/CustomPopup';
import { useDispatch, useSelector } from 'react-redux';
import * as PATH from '../../../CentralisedLink';
import Logo from '../../../Images/dsmlogo2.png';

import {
  FaBars,
  FaAngleLeft,
  FaPlay,
  FaTimes,
  FaHandsHelping,
  FaUser,
  FaRobot,
  FaShieldAlt,
  FaTools,
  FaRocket,
  FaAnchor,
  FaCloud,
  FaMobile,
} from 'react-icons/fa';

import LoadingScreen from '../../../ReusableBlocks/LoadingScreen';
import { deleteCustomerDemoSessionAct } from '../../../Redux/Dashboard/External/SalesDemo/Actions/DeleteDemoSessionAction';
import { updateCustomerDemoSessionAct } from '../../../Redux/Dashboard/External/SalesDemo/Actions/UpdateDemoSessionAction';
import { clearExistingDemoSession } from '../../../Redux/Dashboard/External/SalesDemo/Actions/FetchExistingDemoSessionAction';
import { clearcreateDemoSession } from '../../../Redux/Dashboard/External/SalesDemo/Actions/CreateDemoSessionAction';
import { fetchLearningHub } from '../../../Redux/Dashboard/External/LearningHub/LearningHubGetDataAction';
import { useFeatureFlags } from '../../../FeatureFlags/FeatureFlagsContext';
import { FEATURE_FLAGS } from '../../../FeatureFlags/featureFlagConstants';

import CryptoJS from "crypto-js";

const secretKey = "mySecretKey123"; // Fixed secret key

// Loading Spinner Component
const LoadingSpinner = () => (
  <div className="spinner">
    <div className="double-bounce1"></div>
    <div className="double-bounce2"></div>
  </div>
);



const SalesDashboard = () => {


  // Microcert
  const secretKeyMicro = 'micro';

  const encryptId = (id) => {
    const ciphertext = CryptoJS.AES.encrypt(id, secretKeyMicro).toString();
    return encodeURIComponent(ciphertext);
  };








  // Declaration
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const { isFeatureEnabled } = useFeatureFlags();
  const shouldShowEnablementNav = isFeatureEnabled(FEATURE_FLAGS.EnableEnablement);
  const shouldShowContentStoreNav = isFeatureEnabled(FEATURE_FLAGS.EnableContentStore);
  const shouldShowFaqNav = isFeatureEnabled(FEATURE_FLAGS.EnableFAQ);
  // Id from params
  const { id } = useParams();

  const iconList = [
    <FaUser />,
    <FaRobot />,
    <FaShieldAlt />,
    <FaTools />,
    <FaRocket />,
    <FaAnchor />,
    <FaCloud />,
    <FaMobile />,
  ];
  // States


  const isLoading = useSelector(state => state.UpdateDemoSession?.loading);


  const [initialLoad, setInitialLoad] = useState(true);


  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [selectedDemo, setSelectedDemo] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null); // Stores selected category
  const [selectedCase, setSelectedCase] = useState(null); // Stores selected case
  const [loading, setLoading] = useState(false); // Add loading state
  const iframeRef = useRef(null); // Create a ref for the iframe
  const [showSaveModal, setShowSaveModal] = useState(false);
  const [isNotesVisible, setIsNotesVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768); // Check the window width to determine if we should show the toggle button
  const [comments, setComments] = useState('');
  // Customer Details Form Stats
  const [show, setShow] = useState(false);
  const [customerName, setCustomerName] = useState('');
  const [customerOrg, setCustomerOrg] = useState('');
  const [painPoints, setPainPoints] = useState([]);
  const [isIframeInteracted, setIsIframeInteracted] = useState(false);
  const [showTooltip, setShowTooltip] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [areaOfInterest, setAreaOfInterest] = useState([]);


  const [salesDashboardData, setSalesDashboardData] = useState();


  const [areasCovered, setAreasCovered] = useState(() => {
    // Load from localStorage on initial render
    const savedData = localStorage.getItem("areasCovered");
    return savedData ? JSON.parse(savedData) : [];
  });


  const [isPopupVisible, setIsPopupVisible] = useState(false);

  const ExistingDemoSession = useSelector(state => state.ExistingDemoSession?.demoSession);

  const NewDemoSession = useSelector(state => state.NewSalesDemoSession?.session);



  useEffect(() => {
    const timer = setTimeout(() => {
      setInitialLoad(false); // Hide loading screen after 3 seconds
    }, 2000);

    return () => clearTimeout(timer); // Cleanup timeout on component unmount
  }, []);



  useEffect(() => {

    console.log(ExistingDemoSession);
    console.log(NewDemoSession);

    if (ExistingDemoSession || NewDemoSession) {
      if (!ExistingDemoSession || ExistingDemoSession.length === 0) {
        setSalesDashboardData(NewDemoSession);
      } else if (!NewDemoSession || NewDemoSession.length === 0) {
        setSalesDashboardData(ExistingDemoSession);
      }
      setLoading(false); // Data is now available
    }


  }, [ExistingDemoSession, NewDemoSession]);


  useEffect(() => {
    dispatch(fetchLearningHub());
  }, [dispatch]);


  // Available options for Pain Points
  const painPoint = ['Multiple tools', 'Event Noise', 'Multiple Outages', 'High Operating Cost'];

  const [activeIndex, setActiveIndex] = useState(null);



  // Handlepain points selection
  const handlePainPointSelection = (interest) => {
    setPainPoints((prev) =>
      prev.includes(interest) ? prev.filter((i) => i !== interest) : [...prev, interest]
    );
  };


  useEffect(() => {
    console.log(ExistingDemoSession);
    console.log(NewDemoSession);



    // Display Swal popup only if no demo sessions exist
    if (!ExistingDemoSession && !NewDemoSession) {
      setIsPopupVisible(true);
    } else if (ExistingDemoSession || NewDemoSession) {
      // Process data if demo sessions exist
      if (!ExistingDemoSession || ExistingDemoSession.length === 0) {
        setSalesDashboardData(NewDemoSession);
      } else if (!NewDemoSession || NewDemoSession.length === 0) {
        setSalesDashboardData(ExistingDemoSession);
      }
      setLoading(false); // Data is now available
    }
  }, [ExistingDemoSession, NewDemoSession, navigate, isPopupVisible]);




  useEffect(() => {
    localStorage.setItem("areasCovered", JSON.stringify(areasCovered));
  }, [areasCovered]);






  // Useeffcts
  useEffect(() => {
    const tooltipInterval = setInterval(() => {
      setShowTooltip(true);
      setTimeout(() => setShowTooltip(false), 3000); // Show tooltip for 3 seconds
    }, 10000); // Tooltip reappears every 10 seconds

    return () => clearInterval(tooltipInterval);
  }, []);







  useEffect(() => {
    if (ExistingDemoSession || NewDemoSession) {
      window.addEventListener('beforeunload', handleBeforeUnload);
    } else {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    }

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [ExistingDemoSession, NewDemoSession, salesDashboardData]);





  useEffect(() => {
    if (salesDashboardData && salesDashboardData['persona-details']) {
      const demoDetails = salesDashboardData['persona-details'];
      setSelectedDemo(demoDetails); // Set the full persona details as selected demo
      if (demoDetails.areasOfInterest && demoDetails.areasOfInterest.length > 0) {
        setSelectedCategory(demoDetails.areasOfInterest[0]); // Default to the first use case
        if (demoDetails.areasOfInterest[0].useCases && demoDetails.areasOfInterest[0].useCases.length > 0) {
          setSelectedCase(demoDetails.areasOfInterest[0].useCases[0]); // Default to the first category of the first use case
        }
      }
      setLoading(false); // End loading once data is processed
    }
  }, [salesDashboardData]);






  // Use Effect to retrieve customer details from demoProgress
  useEffect(() => {
    const savedProgress = localStorage.getItem('demoProgress');
    if (savedProgress) {
      const progressData = JSON.parse(savedProgress);
      setCustomerName(progressData.customerName || '');
      setCustomerOrg(progressData.customerOrg || '');
    }
  }, []);






  useEffect(() => {
    const handleResize = () => {
      const isMobileView = window.innerWidth < 768;
      setIsSidebarCollapsed(isMobileView);
      setIsMobile(isMobileView);
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // Initial check on component mount

    return () => window.removeEventListener('resize', handleResize);
  }, []);




  const { title, areasOfInterest } = salesDashboardData?.['persona-details'] || {};
  const customerNametxt = salesDashboardData?.['meeting-notes']?.["Customer Name"] || {};
  const customerOrgtxt = salesDashboardData?.['meeting-notes']?.["Customer Organisation"] || {};

  const demoType = salesDashboardData?.['type'] || {};

  console.log(salesDashboardData?.['type'] || {})



  const toggleNotes = () => {
    setIsNotesVisible(!isNotesVisible);
  };



  // Define handleBeforeUnload in the correct scope
  const handleBeforeUnload = (event) => {
    const demoType = salesDashboardData?.['type'] || '';

    if (demoType !== 'internal' && (ExistingDemoSession || NewDemoSession)) {
      event.preventDefault();
      event.returnValue = ''; // Required for some browsers to show confirmation dialog
      setShowSaveModal(true); // Show custom modal
    }
  };




  const handleOpenModal = () => {
    setIsModalOpen(true);
  };





  const handleCloseModal = () => {
    setIsModalOpen(false);
  };





  const handleIframeClick = () => {
    setIsIframeInteracted(true);

    // Ensure selectedCategory and selectedCase are valid
    if (!selectedCategory || !selectedCase) return;

    const updatedAreasCovered = [...areasCovered];
    const useCaseIndex = updatedAreasCovered.findIndex(
      (item) => item.interestTitle === selectedCategory.interestTitle
    );

    if (useCaseIndex === -1) {
      // Add new use case with the clicked category
      updatedAreasCovered.push({
        interestTitle: selectedCategory.interestTitle,
        useCasesClicked: [selectedCase.useCaseTitle],
      });
    } else {
      // Update existing use case
      const useCasesClicked = updatedAreasCovered[useCaseIndex].useCasesClicked;

      if (!useCasesClicked.includes(selectedCase.useCaseTitle)) {
        useCasesClicked.push(selectedCase.useCaseTitle);
      }
    }

    // Update state and save to localStorage
    setAreasCovered(updatedAreasCovered);
    localStorage.setItem("areasCovered", JSON.stringify(updatedAreasCovered));
  };






  // setSelectedCategory Is areaOfIntreset 
  // setSelectedCase Is UseCase inside the areOfIntreset




  const handleSaveProgress = async () => {
    const payload = {
      painPoints,
      comments,
      areasCovered,
      status: 'in progress', // Update status as required
    };

    try {
      // Await the completion of the dispatch action
      const result = await dispatch(updateCustomerDemoSessionAct(payload));

      if (result) { // Check if the API call was successful
        Swal.fire('Progress Saved!', '', 'success');
        setShowSaveModal(false); // Hide the modal
        window.removeEventListener('beforeunload', handleBeforeUnload); // Allow tab close
        navigate('/home'); // Redirect to home after success
      } else {
        Swal.fire('Failed to Save Progress', 'Please try again.', 'error');
      }
    } catch (error) {
      console.error('Error Saving Progress:', error);
      Swal.fire('An error occurred', 'Please try again later.', 'error');
    }
  };




  // Complete the demo and update demoProgress without removing other fields
  const handleCompleteDemo = () => {
    Swal.fire({
      title: 'Are you sure you want to complete the demo?',
      text: 'This will save all your progress and mark the demo as complete.',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Complete Demo',
      cancelButtonText: 'Cancel',
    }).then((result) => {
      if (result.isConfirmed) {
        const payload = {
          painPoints,
          comments,
          areasCovered,
          status: 'completed', // You can change this to 'complete' based on your requirements
        };

        // Dispatch the API action
        dispatch(updateCustomerDemoSessionAct(payload))
          .then(() => {
            // Clear the existing demo sessions after completion
            dispatch(clearExistingDemoSession());
            dispatch(clearcreateDemoSession());
            setIsPopupVisible(true);
            // Show the popup after successful API response
          })
          .catch((error) => {
            console.error("Failed to save demo progress:", error);
            Swal.fire('Failed to save demo progress', '', 'error');
          });


        // Close the form modal
      }
    });
  };





  // Handle form submit for meeting notes, same process for demoProgress
  const handleSubmit = (e) => {
    e.preventDefault();

    // Check for empty pain points
    if (painPoints.length === 0) {
      Swal.fire({
        title: 'Missing Pain Points',
        text: 'Please select at least one pain point before submitting.',
        icon: 'warning',
        confirmButtonText: 'Okay',
      });
      return; // Stop the form submission if validation fails
    }

    // Check for empty comments
    if (comments.trim() === '') {
      Swal.fire({
        title: 'Missing Comments',
        text: 'Please add your comments before submitting.',
        icon: 'warning',
        confirmButtonText: 'Okay',
      });
      return; // Stop the form submission if validation fails
    }

    // If both validations pass, proceed
    handleCompleteDemo();
  };





  // Toggle function to expand/collapse the sidebar
  const toggleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };





  if (loading) {
    // If loading, show the spinner
    return <LoadingSpinner />;
  }



  // Function to handle full screen for iframe
  const handleFullScreen = () => {
    if (iframeRef.current) {
      const iframe = iframeRef.current;
      if (iframe.requestFullscreen) {
        iframe.requestFullscreen();
      } else if (iframe.mozRequestFullScreen) {
        iframe.mozRequestFullScreen(); // Firefox
      } else if (iframe.webkitRequestFullscreen) {
        iframe.webkitRequestFullscreen(); // Chrome, Safari, and Opera
      } else if (iframe.msRequestFullscreen) {
        iframe.msRequestFullscreen(); // IE/Edge
      }
      handleIframeClick()

    }

  };





  // Function to handle the back click event
  const handleBackClick = (e) => {
    e.preventDefault(); // Prevent direct navigation

    // Allow tab close if demoType is "internal"
    const isInternalDemo = salesDashboardData?.['type'] || {};

    if (isInternalDemo !== "internal") {
      setShowSaveModal(true); // Show save confirmation modal
    }
    else {
      navigate('/home');
    }
  };



  // Function to discard progress and navigate
  const handleDiscardProgress = async () => {
    try {
      const response = await dispatch(deleteCustomerDemoSessionAct()); // Wait for the API response

      // Check if the response contains the expected success message
      console.log('Response from API:', response);
      if (response?.success) {
        setShowSaveModal(false); // Hide the modal
        window.removeEventListener('beforeunload', handleBeforeUnload); // Allow tab close
        navigate('/home'); // Redirect to the home page
      } else {
        Swal.fire('Failed to discard progress', 'Please try again.', 'error');
      }
    } catch (error) {
      console.error('Error discarding progress:', error);
      Swal.fire('An error occurred', 'Please try again later.', 'error');
    }
  };



  // Function to cancel the navigation
  const handleCancel = () => {
    setShowSaveModal(false); // Close modal without action
  };



  const handleOpenSecureView = () => {
    handleIframeClick()
    const encryptedSession = CryptoJS.AES.encrypt(selectedCase.navaticUrl, secretKey).toString(); // Encrypt
    sessionStorage.setItem("secureNavaticURL", encryptedSession); // Store encrypted URL
    window.open(`/secure-view`, "_blank"); // Open the secure viewer
  };



  return (
    <>

      {isLoading && <LoadingScreen text="Loading..." />}
      {initialLoad && <LoadingScreen text="Loading..." />}

      <div className="dashboard-container">


        {/* Sidebar Container */}
        <motion.div
          className={`sidebar-container ${isSidebarCollapsed ? 'sidebar-collapsed' : ''}`}
          initial={{ width: isSidebarCollapsed ? 80 : 240 }}
          animate={{ width: isSidebarCollapsed ? 80 : 240 }}
          transition={{ duration: 0.3 }}
        >
          {/* Toggle Icon - only show if on mobile */}
          {isMobile && (
            <div className="sidebar-header">
              <FaBars className="toggle-icon" onClick={toggleSidebar} />
            </div>
          )}


          {/* Toggle Icon - only show if on mobile */}
          {!isMobile && (
            <div className="sidebar-header">
              <Link to='/home'><img src={Logo} alt="Brand Logo" className="brand-logo" /></Link>
            </div>
          )}



          {/* Sidebar Options */}
          <div className="sidebar-options">
            {areasOfInterest?.map((category, index) => (
              <div
                key={index}
                className={`sidebar-option ${selectedCategory?.interestTitle === category.interestTitle ? "active" : ""}`} // Highlight selected category
                onClick={() => {
                  setSelectedCategory(category); // Set the selected category
                  setSelectedCase(category.useCases[0]); // Set the first case in the category as default
                }}
              >

                {isSidebarCollapsed ? (
                  <>
                    <i className="sidebar-icon"> {iconList[index % iconList.length]}</i> {/* Replace with appropriate icon if needed */}
                    <span className="tooltip">{category.interestTitle}</span>
                  </>

                ) : (
                  <motion.span
                    initial={{ opacity: isSidebarCollapsed ? 0 : 1 }}
                    animate={{ opacity: isSidebarCollapsed ? 0 : 1 }}
                    transition={{ duration: 0.3 }}
                    className="sidebar-text"
                  >
                    <span className="sidebar-content">
                      <i className="sidebar-icon-2"> {iconList[index % iconList.length]}</i>
                      <span className="sidebar-label">{category.interestTitle}</span>
                    </span>

                  </motion.span>
                )}
              </div>
            ))}
          </div>



          {/* Sidebar Footer */}

          <div className="sidebar-footer">
            <div onClick={handleBackClick} style={{ textDecoration: 'none' }}>
              <FaAngleLeft className="toggle-icon-back" />
              <span className="footer-text">Back to Home</span>
            </div>
          </div>
        </motion.div>


        {/* <WarningBar message="Please remember to submit the meeting notes once you complete the demo to finalize this session." /> */}


        {/* Main Content Container */}
        <div className="main-content-container">



          {/* Top Bar */}
          <div className="top-bar-container">
            <div className="top-bar-header">
              <h2>
                {selectedDemo?.title} - <span className='category-style-text'>{selectedCategory?.interestTitle}</span>
              </h2>
            </div>

          </div>





          <div className="main-inside-container">


            {/* Cards Section */}
            <div className="row">
              {selectedCategory?.useCases.map((card, index) => (
                <div className="col-lg-3 col-md-6 mb-6" key={index}>
                  <div
                    className={`dashboard-card ${selectedCase === card ? 'active' : ''}`}
                    onClick={() => setSelectedCase(card)}
                  >
                    <Card.Body>
                      <Card.Title className="sales-card-text-size">{card.useCaseTitle}</Card.Title>
                    </Card.Body>
                  </div>
                </div>
              ))}
            </div>




            {selectedCase?.microcertTitle && selectedCase?.certId && (
  <motion.div
    className="sale-sugg-micro-container"
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.6, ease: "easeOut" }}
  >
    <span className="sale-sugg-micro-label">Suggested Microcert: </span>
    <Link
      to={`${PATH.LEARNING_HUB_MICROCERTS_PATH}${selectedCase?.trackTitle}/${encryptId(selectedCase?.certId)}`}
      className="sale-sugg-micro-link"
    >
      {selectedCase.microcertTitle}
    </Link>
  </motion.div>
)}




            {/* Link and Short Notes Section */}
            <div className="row">

              <motion.div
                className={`col-lg-${isNotesVisible ? '8' : '12'} mb-8`}
                style={{ transition: 'width 0.5s ease', }}>
                <div className="video-wrapper-2" style={{
                  zIndex: 1,
                  position: 'relative',
                  paddingBottom: '56.25%',
                }}>


                  <iframe
                    ref={iframeRef}
                    src={selectedCase?.navaticUrl || 'https://www.youtube.com/embed/dQw4w9WgXcQ'}
                    title="YouTube video"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    style={{
                      position: 'absolute',
                      top: '0',
                      left: '0',
                      width: '100%',
                      height: '100%', // Changed to 100% to cover the wrapper fully
                      border: 'none',
                      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.5)',
                    }}
                    onLoad={() => setIsIframeInteracted(true)}
                  />


                  <div className="overlay34">

                    <div className="thumbnail-overlay" /> {/* Added black overlay */}

                    {/* Overlay heading with increased z-index */}
                    <h3 className="overlay-heading" style={{ zIndex: 2 }}>{selectedCase?.title}</h3>

                    <FaPlay className="play-button" style={{ zIndex: 2 }}
                      // onClick={handleIframeClick} 
                      onClick={(e) => {
                        e.stopPropagation(); // Prevent fullscreen trigger
                        // window.open(selectedCase.navaticUrl, "_blank");
                        handleOpenSecureView();
                      }}
                    />
                  </div>






                  {/* <FaExpand
                    className="fullscreen-icon"
                    onClick={handleFullScreen}
                    style={{
                      position: 'absolute',
                      bottom: '15px',
                      right: '15px',
                      cursor: 'pointer',
                      color: '#007bff',
                      fontSize: '28px',
                    }}
                  /> */}



                  <div className="notes-toggle-icon" onClick={toggleNotes}>
                    {isNotesVisible ? <FaTimes className="icon" /> : <span className="vertical-text">Demo Talk Track</span>}
                  </div>



                </div>


              </motion.div>

              {/* Notes Slide-out */}
              {isNotesVisible && (
                <motion.div
                  className="col-lg-4 notes-slide-out"
                  initial={{ opacity: 0, x: 200 }}
                  animate={{ opacity: 1, x: 0 }}
                  exit={{ opacity: 0, x: 200 }}
                  transition={{ duration: 0.5 }}
                  style={{ position: 'relative', zIndex: 2 }}
                >
                  <div className="description-wrapper">
                    {/* Problem Statement Section */}
                    <h3 className="section-title">Problem Statement</h3>
                    <div className="notes-group">
                      {selectedCase?.notes["Problem Statement"].map((note, idx) => (
                        <motion.div
                          className={`card-sales ${idx === activeIndex ? 'active-card' : ''}`}
                          key={`problem-${idx}`}
                          onClick={() => setActiveIndex(idx)}
                          initial={{ opacity: 0, rotateX: -90 }}
                          animate={{ opacity: 1, rotateX: 0 }}
                          exit={{ opacity: 0, rotateX: 90 }}
                          transition={{ duration: 0.8 }}
                        >
                          <p className="note-p">{note}</p>
                        </motion.div>
                      ))}
                    </div>

                    {/* BMC Proposition Section */}
                    <h3 className="section-title">BMC Proposition</h3>
                    <div className="notes-group">
                      {selectedCase?.notes["BMC Proposition"].map((note, idx) => (
                        <motion.div
                          className={`card-sales ${idx + 3 === activeIndex ? 'active-card' : ''}`}
                          key={`bmc-${idx}`}
                          onClick={() => setActiveIndex(idx + 3)}
                          initial={{ opacity: 0, rotateX: -90 }}
                          animate={{ opacity: 1, rotateX: 0 }}
                          exit={{ opacity: 0, rotateX: 90 }}
                          transition={{ duration: 0.8 }}
                        >
                          <p className="note-p">{note}</p>
                        </motion.div>
                      ))}
                    </div>
                  </div>
                </motion.div>

              )}


            </div>


            <br></br>
            <br></br>


            {/* Copyright Text */}
            <div className="footer-sales">
              <div className="copyright-text-sales">
                © Copyright 2026 BMC Helix
              </div>

              <div className="footer-links-sales">
                {shouldShowEnablementNav && (
                  <Link to={`${PATH.LEARNING_HUB_PATH}`} className="nav-link-sale-sales">
                    Learning Hub
                  </Link>
                )}
                {shouldShowContentStoreNav && (
                  <Link to={`${PATH.CONTENT_STORE_PATH}`} className="nav-link-sale-sales">
                    Content Store
                  </Link>
                )}
                {shouldShowFaqNav && (
                  <Link to={`${PATH.FAQ_PATH}`} className="nav-link-sale-sales">
                    FAQ
                  </Link>
                )}
                <Link to={`${PATH.PROFILE_PATH}`} className="nav-link-sale-sales">
                  Profile
                </Link>
              </div>
            </div>

          </div>
        </div>
      </div>


      {/* Modal for Request Demo */}
      <Modal
        size="lg"
        show={isModalOpen}
        fullscreen={true}
        onHide={handleCloseModal}
        centered>
        <Modal.Body style={{ padding: 0 }} className="p-0">
          <div className="survey-container">
            <div className="row g-0 align-items-center justify-content-center w-100 m-0">
              <div className="col-lg-6 col-md-8 col-sm-10 p-0">
                <div className="survey-box">
                  <h6 className="survey-title">Meeting Notes</h6>


                  <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3" controlId="customerName">
                      <Form.Label className='labl-sales'>Customer Name</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Customer Name"
                        disabled
                        value={customerNametxt}
                        onChange={(e) => setCustomerName(e.target.value)}
                        required
                      />
                    </Form.Group>

                    {/* Customer Organization */}
                    <Form.Group className="mb-3" controlId="customerOrg">
                      <Form.Label className='labl-sales'>Customer Organization</Form.Label>
                      <Form.Control
                        type="text"
                        disabled
                        placeholder="Customer Organization"
                        value={customerOrgtxt}
                        onChange={(e) => setCustomerOrg(e.target.value)}
                        required
                      />
                    </Form.Group>



                    {/* Areas of Interest */}
                    <Form.Group className="mb-3" controlId="areaOfInterest">
                      <Form.Label className='labl-sales'>Choose Pain Points</Form.Label>
                      <div className="interest-container">
                        {painPoint.map((interest, idx) => (
                          <Button
                            key={idx}
                            variant={painPoints.includes(interest) ? 'secondary' : 'outline-dark'}
                            onClick={() => handlePainPointSelection(interest)}
                            className="m-1"
                          >
                            {interest}
                          </Button>
                        ))}
                      </div>
                    </Form.Group>



                    {/* Comment Field */}
                    <Form.Group className="mb-3" controlId="comments">
                      <Form.Control
                        as="textarea"
                        rows={3}

                        className="fixed-height-textarea"
                        placeholder="Add any additional comments"
                        value={comments}
                        onChange={(e) => setComments(e.target.value)}
                      />
                    </Form.Group>

                    {/* Submit Button */}
                    <Button
                      variant="primary"
                      type="submit"
                      className="w-100 custom-button"
                    >
                      Submit
                    </Button>
                  </Form>

                  
                  <center><p className='cancel-btn-sale' onClick={handleCloseModal}>Cancel</p></center>
                </div>
              </div>

              {/* Image section */}
              <div className="col-lg-6 d-none d-lg-block survey-image-container p-0">
                <img
                  src="https://res.cloudinary.com/dueblmbcc/image/upload/v1727815344/Navatic/kkii_volmad.jpg"
                  alt="Survey Visual"
                  className="survey-image w-100"
                />
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>


      {demoType !== "internal" && (
        <div className="sales-floating-button-container">
          {!isModalOpen && (
            <motion.button
              className="sales-floating-button"
              onClick={handleOpenModal}
              initial={{ opacity: 0 }}
              animate={{ opacity: isIframeInteracted ? 1 : 0 }}
              transition={{ duration: 0.5 }}
            >
              <FaHandsHelping className="sales-floating-icon" />
              {showTooltip && (
                <motion.span
                  className="sales-floating-tooltip show"
                  initial={{ opacity: 0, x: 20 }}
                  animate={showTooltip ? { opacity: 1, x: 0 } : { opacity: 0, x: 20 }}
                  transition={{ duration: 0.4, ease: "easeInOut" }}
                >
                  Meeting Notes
                </motion.span>
              )}
            </motion.button>
          )}
        </div>
      )}


      <Modal show={showSaveModal} onHide={handleCancel} className="sales-mode-modal">
        <div className="sales-mode-modal-content">
          {/* Custom Header within the Body */}
          <div className="sales-mode-modal-header">
            <span className="icon">⚠️</span>
            <span>Save Progress</span>
          </div>

          {/* Modal Body */}
          <div className="sales-mode-modal-body">
            You have unsaved progress. Would you like to save it before going back to the home page?
          </div>

          {/* Footer Buttons */}
          <div className="sales-mode-modal-footer">
            <Button className="sales-mode-button sales-mode-button-cancel" onClick={handleDiscardProgress}>
              Discard Progress
            </Button>
            <Button className="sales-mode-button sales-mode-button-continue" onClick={handleSaveProgress}>
              Save Progress
            </Button>
          </div>
        </div>
      </Modal>



      {isPopupVisible && (
        <CustomPopup
          message="Thank You!"
          subMessage="Your details have been successfully submitted. Try new Personas"
          onClose={() => setIsPopupVisible(false)}
        />
      )}



    </>
  );
};

export default SalesDashboard;

